/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { AssetFragmentDoc } from "./fragments.service.graphql-gen";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetAssetQueryVariables = Types.Exact<{
	input: Types.AssetInput;
	period?: Types.InputMaybe<Types.TimePeriod>;
	includeOHLC: Types.Scalars["Boolean"];
}>;

export type GetAssetQuery = {
	__typename?: "Query";
	asset?:
		| { __typename?: "CommodityAsset" }
		| {
				__typename?: "CryptoAsset";
				marketCap?: { value: string; precision: number } | null;
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				staking?: { __typename?: "Staking"; estimatedRewards: { value: string; precision: number } } | null;
				marginLongSettings?: {
					__typename?: "AssetMarginSettings";
					maximumLeverage?: number | null;
					buyActive?: boolean | null;
					sellActive?: boolean | null;
					automatedOrderEnabled?: boolean | null;
				} | null;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
				logos: Array<{
					__typename?: "Image";
					height: number;
					mimeType: string;
					theme?: Types.UiTheme | null;
					url: string;
					width: number;
				}>;
		  }
		| { __typename?: "EquityComplexEtfAsset" }
		| { __typename?: "EquityEtcAsset" }
		| { __typename?: "EquityEtfAsset" }
		| { __typename?: "EquityRightAsset" }
		| { __typename?: "EquityStockAsset" }
		| { __typename?: "EtfAsset" }
		| { __typename?: "GenericAsset" }
		| { __typename?: "IndexAsset" }
		| { __typename?: "LeverageAsset" }
		| { __typename?: "MetalAsset" }
		| { __typename?: "SecurityTokenAsset" }
		| { __typename?: "StockAsset" }
		| null;
};

export const GetAssetDocument = gql`
	query GetAsset($input: AssetInput!, $period: TimePeriod, $includeOHLC: Boolean!) {
		asset(input: $input) {
			...Asset
		}
	}
	${AssetFragmentDoc}
`;

@Injectable({
	providedIn: "root"
})
export class GetAssetGQLService extends Apollo.Query<GetAssetQuery, GetAssetQueryVariables> {
	document = GetAssetDocument;
	client = "bff";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
